import { gql } from '@apollo/client';

export const SEARCH_TRACKING_FEEDBACK = gql`
    mutation SearchTrackingFeedback($trackingFeedback: TrackingFeedback!) {
        searchTrackingFeedback(trackingFeedback: $trackingFeedback)
    }
`;
